import React, { useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import '@fortawesome/fontawesome-svg-core/styles.css'

import Header from '../Header'
import Menu from '../Menu'
import Footer from '../Footer'

import GlobalStyle from '../../styles/global.css'

import {StLayout} from './style.css'

import { library, config } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

import ProgressBar from '../ProgressBar'

config.autoAddCss = false

library.add(fab, fas, far)

const Layout = ({sponsorLogo, children}) => {
  const [ activeMenu, setactiveMenu ] = useState(false)

  const handleToggleMenu = () => {
    setactiveMenu(!activeMenu)
  }

  const { site } = useStaticQuery(
    graphql`
		query {
      site {
        siteMetadata {
          title
        }
      }
	  }
	`)
  return (
    <StLayout>
      <GlobalStyle />
      <ProgressBar height={3} />
      <Header siteTitle={site.siteMetadata.title} sponsorLogo={sponsorLogo} handleToggleMenu={() => handleToggleMenu()} activeMenu={activeMenu} />
      {children}
      <Menu active={activeMenu} handleToggleMenu={() => handleToggleMenu()} />
      <Footer />
    </StLayout>
  )
}

export default Layout